// Loads the product forms from products.json and validates against
// ProductSchema at module load — same contract as recipes.ts. Malformed data
// fails the build loudly instead of rendering a broken page.

import productsJson from './products.json';
import { Product, ProductsSchema } from '../schemas/product';

export type { Product };
export const PRODUCTS: Product[] = ProductsSchema.parse(productsJson);
